/**
 * Marca de água diagonal "AIOBI · CONFIDENCIAL" — visível em todas as views.
 * Fixed, pointer-events:none, opacidade definida via CSS var --watermark-color
 * (adapta-se ao modo claro/escuro).
 */
export function Watermark({ label = 'AIOBI · CONFIDENCIAL' }: { label?: string }) {
  return (
    <div className="aiobi-watermark" aria-hidden="true">
      <span className="aiobi-watermark__text">{label}</span>
    </div>
  );
}
